import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "~/common/renderFromPreloadedJSON";
import FoodServiceResourcesCategories from "./FoodServiceResourcesCategories";

whenDomReady(() => {
  renderFromPreloadedJSON(
    FoodServiceResourcesCategories,
    "FoodServiceResourcesCategories",
  );
});
